<div class="card">
    <div class="card-header">
        Listado de {{entity | uppercase }}
    </div>
    <div class="card-body">

        <app-fil-ingreso (filter)="doFound($event)">
        </app-fil-ingreso>

        <div class="row table-responsive">
            <table class="table table-striped table-inverse">
                <thead class="thead-inverse">
                    <tr>
                        <!-- <th>id</th> -->
                        <th>Fecha</th>
                        <th>Ingresar</th>
                        <th>Comprobante | remito</th>
                        <th>Descripción</th>
                        <th>acción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items">
                        <!-- <td scope="row">{{item.id}} </td> -->
                        <td>{{item.fecha | date :'dd-MM-yyyy'}} </td>
                        <td>{{item.motivo}}</td>
                        <td>{{item.nroFactura}}</td>
                        <td>{{view(item.descripcion) }}</td>
                        <td>
                            <button type="button" (click)="linkear(item.id)" class="btn btn-info btn-sm">
                                <i class="fas fa-edit    "></i> editar
                            </button> &nbsp;
                            <!-- <button type="button" (click)="preDelete(item)" class="btn btn-danger btn-sm">
                                <i class="fas fa-trash    "></i> eliminar
                            </button> -->


                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer text-muted">
        <div class="btn-group" role="group" aria-label="">
            <a (click)="linkear(0)" class="btn btn-dark">Agregar</a>
        </div>
    </div>
</div>